import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ScrollManager from "./components/feature/ScrollManager";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { MetaPixelProvider } from "./context/MetaPixelContext";
import SessionRecoveryBanner from "./components/feature/SessionRecoveryBanner";
import SistecreditoPendingSync from "./components/feature/SistecreditoPendingSync";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollManager />
        <MetaPixelProvider>
          <AuthProvider>
            <CartProvider>
              <SessionRecoveryBanner />
              <SistecreditoPendingSync />
              <AppRoutes />
            </CartProvider>
          </AuthProvider>
        </MetaPixelProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;